<div class="tile-padding-first tile-padding">
  <ng-template #utilityBarForm>
    <!-- tw:pt-4/pb-4/px-3 is the utility-bar content inset used by the other search panels.
         The form's own padding is zeroed inline: the unlayered global form{padding:10px} beats
         any layered Tailwind utility, so it would otherwise stack on top of this wrapper. -->
    <div class="tw:pt-4 tw:pb-4 tw:px-3">
      @if (errorMsg) {
        <label class="tw:text-danger">{{errorMsg}}</label>
      }
      <form [formGroup]="frmUserSearch" style="padding: 0; margin: 0;">
        <div class="flex-search-container" [class.filter-bar]="filtersEnabled">
          <div fxLayout="column" fxLayout.gt-md="row" fxLayoutWrap fxLayoutGap="1%" class="flex-search-sub filter-bar__group">
            <div fxLayout.gt-md="column" class="filter-bar__field">
              <div>
                <label class="field__label">Date From</label>
                <input type="date" class="field__control" formControlName="startDate" (input)="datePreset = null"
                  data-toggle="tooltip" data-placement="top" title="Please select a from date">
                </div>
              </div>
              <div fxLayout.gt-md="column" class="filter-bar__field">
                <div>
                  <label class="field__label">Date To</label>
                  <input type="date" class="field__control" formControlName="endDate" (input)="datePreset = null"
                    data-toggle="tooltip" data-placement="top" title="Please select a to date">
                  </div>
                </div>
                <div fxLayout.gt-md="column" class="filter-bar__field">
                  <crm-user-select></crm-user-select>
                </div>
                <div fxLayout.gt-md="column" class="filter-bar__group" *appFeatureSwitch="featureKeys.filtersActions">
                  <app-brand-filter class="filter-bar__field" [companyIds]="companyIds"
                    (companyIdsChange)="companyIds = $event"></app-brand-filter>
                </div>
                @if (!filtersEnabled) {
                  <div fxLayout.gt-md="column">
                    <div><label class="field__label tw:invisible">&nbsp;</label></div>
                    <button class="btn-outline-primary btn" style="height: 38px;" name="Search" value="Search" (click)="searchAction()">Search</button>
                  </div>
                }
              </div>
              @if (filtersEnabled) {
                <div class="filter-bar__actions">
                  <div class="filter-bar__presets">
                    <app-date-presets [selected]="datePreset" (presetSelected)="onDatePreset($event)"></app-date-presets>
                  </div>
                  <div class="filter-bar__buttons">
                    <app-filter-clear-all (clear)="clearAll()"></app-filter-clear-all>
                    <button class="btn btn-primary" name="Search" value="Search" (click)="searchAction()">Search</button>
                  </div>
                </div>
              }
            </div>
          </form>
        </div>
      </ng-template>

      <div class="grid-secondary">
        <div class="tile-padding">
          @if (nodataStr) {
            <div class="no-data-found">
              <label>{{nodataStr}}</label>
            </div>
          }
          <div [hidden]="noData">
            <div class="header-tile">Pending Actions</div>
            <div class="table-container">
              <mat-table [dataSource]="dataSource" class="flex-container">
                <ng-container matColumnDef="user">
                  <mat-header-cell *matHeaderCellDef> Date </mat-header-cell>
                  <mat-cell *matCellDef="let element" class="{{element.highlightUser ? 'flex-item mat-elevation-z8-hilighted hilighted' : 'flex-item mat-elevation-z8' }} ripple" (click)="onDataclicked(element)">
                    <div>{{element.user[0].coordinatorName}}</div>
                    <div class="circle">{{element.actions}}</div>
                  </mat-cell>
                </ng-container>
                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
              </mat-table>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="container-fluid">
      <div class="row">
        <div class="col">
          <bar-chart></bar-chart>
        </div>
        <div class="col">
          <bubble-chart></bubble-chart>
        </div>
        <div class="col">
          <doughnut-chart></doughnut-chart>
        </div>
        <div class="col">
          <line-chart></line-chart>
        </div>
        <div class="col">
          <pie-chart></pie-chart>
        </div>
        <div class="col-6">
          <radar-chart></radar-chart>
        </div>
      </div>
    </div> -->
  </div>
